var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-default-dialog-appbar',{attrs:{"back-to":_vm.rotaabastecimento,"withDialog":""}},[_vm._v(" Cadastro Abastecimento ")])
}
var staticRenderFns = []

export { render, staticRenderFns }